import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from '@environments/environment';
import { concatMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CountriesService {

    private countriesSubject: BehaviorSubject<any>;

    constructor(private http: HttpClient) {
        this.countriesSubject = new BehaviorSubject(false)
    }

    getCountries() {
        if (this.countriesSubject.value) {
            return of(this.countriesSubject.value);
        } else {
            return this.http.get<any>(`${environment.apiUrl}/countries`).pipe(
                concatMap((response) => {
                    return new Observable((observer) => {
                        if (response && response.code == 200) {
                            this.countriesSubject.next(response.data)
                            observer.next(response.data);
                        } else {
                            observer.next([]);
                        }
                        observer.complete();
                    })
                })
            );
        }
    }


    getActiveCountries(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/countries/active`).pipe(
            concatMap((response) => {
                return new Observable((observer) => {
                    if (response && response.code == 200) {
                        observer.next(response.data);
                    } else {
                        observer.next([]);
                    }
                    observer.complete();
                })
            })
        );
    }
}
